export default __webpack_public_path__ + "static/media/11.3dfbed32.png";